import React, { useState, useEffect, useRef } from "react";
import "./SignIn.css";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import { clearUserDetails, setUserDetails } from "../../../Redux/Slices/userDetailsSlice";
import Cookies from "js-cookie";
import { signin } from "../../../api/auth";
import { setAuthTokens, debugTokenStorage } from "../../../api/index";
import Loader from "../../Loader";
import { getRedirectPath, clearRedirectPath } from "../../../utils/authRedirect";
import { SimplifyCaptcha } from 'simplify-captcha';
import { colors } from "@mui/material";

const signInOptions = [
  "/SignIn/google.svg",
  "/SignIn/apple.svg",
  "/SignIn/facebook.svg",
  "/SignIn/twitter.svg",
];


function SignIn() {

  const [email, setEmail] = useState(() => localStorage.getItem("savedEmail") || "");
  const [password, setPassword] = useState(() => localStorage.getItem("savedPassword") || "");
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rememberMe, setRememberMe] = useState(false);
  const userDetails = useSelector((state) => state.userDetails.userDetails);
  const captchaRef = useRef(null);

  const emailOnChange = (e) => {
    setEmail(e.target.value);
    if (passwordError) {
      setPasswordError("");
    }
  };
  const passwordOnChange = (e) => {
    setPassword(e.target.value);
    if (passwordError) {
      setPasswordError("");
    }
  };

  const handleForgetPasswordClick = () => {
    dispatch(setActiveComponent("forgetPassword"));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const checkValidCredentials = () => {
    if (!email && !password) {
      setPasswordError("Please enter email and password to sign in");
      return false;
    } else if (!email && password) {
      setPasswordError("Please enter email to sign in");
      return false;
    } else if (!password && email) {
      setPasswordError("Please enter password to sign in");
    } else if (!isValidEmail(email) && email.length > 0) {
      setPasswordError("Invalid email format");
      return false;
    } else if (password.length < 8 && password.length > 0) {
      setPasswordError("Password must be more than 8 digits");
      return false;
    } else return true;
  };
  const handleSignIn = async () => {
    if (isLoading) return;
    if (!checkValidCredentials()) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    try {
      const response = await signin({
        email: email,
        password: password,
      });
      console.log("Login Success", response?.data);

      // Normalize API payload shape
      const top = response?.data || {};
      const payload = top?.data || top; // some endpoints nest under data

      // Persist user details
      const userDetails = payload?.userDetails || top?.userDetails || null;
      if (userDetails) {
        dispatch(setUserDetails(userDetails));
      }

      if ((userDetails?.roleName || payload?.user?.roleName) !== 'User') {
        setPasswordError("You are not authorized to access this application");
        setIsLoading(false);
        return;
      }
      if (rememberMe) {
        localStorage.setItem('savedEmail', email);
        localStorage.setItem('savedPassword', password);
      } else {
        localStorage.removeItem('savedEmail');
        localStorage.removeItem('savedPassword');
      }
      const UserId = userDetails?.userId || payload?.user?.userId || payload?.data?.userDetails?.userId || null;
      if (UserId) {
        localStorage.setItem("userId", UserId);
      }

      // Store tokens robustly
      const tokensCandidate = payload?.tokens || payload;
      setAuthTokens(tokensCandidate);
      const tokenDebug = debugTokenStorage?.();
      console.log('Token storage after signin:', tokenDebug);
      const target = getRedirectPath();
      clearRedirectPath();
      navigate(target, { replace: true });   
      // const userData = response.data.userDetails; 
      // const redirectPath = localStorage.getItem('redirectAfterSignIn');
      // if (redirectPath) {
        
      //   localStorage.removeItem('redirectAfterSignIn'); 
      //   navigate(redirectPath, { replace: true });
      // } else {
      //   if (userData?.firstName === null || userData?.lastName === null) {
      //     dispatch(setActiveComponent("enterName"));
      //     navigate('/signup', { replace: true });
      //   } else if (userData?.gender === null) {
      //     dispatch(setActiveComponent("enterPersonalDetails"));
      //     navigate('/signup', { replace: true });
      //   } else if (userData?.addresses.length === 0) {
      //     dispatch(setActiveComponent("enterAddress"));
      //     navigate('/signup', { replace: true });
      //   } else if (userData.faceId === null) {
      //     dispatch(setActiveComponent("faceRecognition1"));
      //     navigate('/signup', { replace: true });
      //   } else {
      //     navigate('/ballots', { replace: true });
      //   }
      // }
    } catch (error) {
      console.log("Login Err", error?.response?.data?.message);
      setPasswordError(error?.response?.data?.message || error?.message || error?.data?.message || "Invalid Credentials or user doesn't exist");
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleCaptchaClick(e);
    }
  };

  const handleCaptchaResult = (e) => {
    const { data } = e.nativeEvent;
    switch (data) {
      case 'verified':
        console.log('✅ User verified successfully!');
        handleSignIn();
        break;
      case 'cancel':
        console.log('❌ User cancelled verification');
        break;
      case 'error':
        console.log('❌ Verification failed - too many attempts');
        break;
      default:
        console.log('❌ Verification failed - too many attempts');
        break;
    }
  };

  const handleCaptchaClick = () => {
    if (!checkValidCredentials()) {
      setIsLoading(false);
      return;
    }
    captchaRef.current?.show();
  };

  return (
    <div className="SignIn">
      <div className="signInContainer">
        <span className="signInText">Sign In</span>
        <span className="signInText2"> Sign In to Unite on Amalgamate</span>

        <div className="parentInputContainer">
          <div className="generalInputContainer">
            <label htmlFor="emailInput" className="labelText">
              Email 
            </label>
            <div className="inputContainerWrapper">
              <input
                id="emailInput"
                className="input"
                type="text"
                placeholder="Type your e-mail or phone number"
                value={email}
                onChange={(e) => emailOnChange(e)}
                onKeyDown={handleKeyPress}
              />
            </div>
          </div>
          <div className="generalInputContainer">
            <label htmlFor="password" className="labelText">
              Password
            </label>
            <div className="inputContainerWrapper">
              <input
                id="password"
                className="input"
                type={showPassword ? "text" : "password"}
                placeholder="Type your password"
                value={password}
                onChange={(e) => passwordOnChange(e)}
                onKeyDown={handleKeyPress}
              // onBlur={checkValidCredentials}
              />
              <span
                className="eyeIcon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <RemoveRedEyeRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                ) : (
                  <VisibilityOffRoundedIcon
                    sx={{
                      fontSize: {
                        xs: "12px",   // extra-small devices
                        sm: "14px",   // small devices
                        md: "16px",   // medium devices
                        lg: "18px",   // large devices
                        xl: "20px",   // extra-large devices
                      },
                    }}
                  />
                )}
              </span>
              {passwordError && (
                <span className="errorTooltip">{passwordError}</span>
              )}
            </div>
            {/* <div className="toolTipContainer"> */}
            <div className="forgetPasswordContainer">
              <label className="checkboxContainer">
                <input type="checkbox" className="rememberMeCheckbox" checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)} />
                <span className="labelText" style={{ whiteSpace: 'nowrap' }}>Remember me</span>
              </label>
              <div
                className="forgetPasswordText"
                onClick={handleForgetPasswordClick}
              >
                Forget Password?
              </div>
            </div>

          </div>
        </div>
        {/* <div className="signInButtonContainer"> */}
        <button
          className="btnContainer"
          onClick={handleCaptchaClick}
          disabled={isLoading}
        >
          {isLoading ? <Loader /> : <span className="btnText">Sign In</span>}
        </button>
        {/* </div> */}
        <SimplifyCaptcha
          ref={captchaRef}
          onMessage={handleCaptchaResult}
          style={{ 
            borderColor: '#2D2E33',
            backgroundColor: '#071414',
            color: 'white'
          }}
        />

        {/* <div className="signInDividerContainer">
          <div className="signDivider1"></div>
          <span className="otherAccountsText">or do it via other accounts</span>
          <div className="signDivider2"></div>
        </div>
        <div className="signInOptionsContainer">
          {signInOptions.map((item, index) => {
            return (
              <div className="optionIconContainer" key={index}>
                <img src={item} alt="no img found" className="optionsIcon" />
              </div>
            );
          })}
        </div> */}

        {/* <div className="appAvailableFor">
          <span className="appAvailableForText">App Available For</span>
          <div className="iconContainer">
            <div className="iconContainer2">
              <img
                src="/LandingPage/playstoreIcon.svg"
                className="smallIcon"
                alt="no img found"
              />
              <div className="verticalLine"></div>
              <img
                src="/LandingPage/appStoreIcon.svg"
                className="smallIcon"
                alt="no img found"
              />
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default SignIn;
